import React, { ReactElement } from 'react';

import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';
import useSheet from '../../../../../mobile/structural/sheet/hooks/useSheet';
import Icon from '../../../../../components/icons/Icon';
import ToolbarTool from '../../ToolbarTool';
import MobileTableCellAlignmentSheet from './MobileTableCellAlignmentSheet';
import useTableCellAlignmentToolState from './useTableCellAlignmentToolState';

type MobileTableCellAlignmentToolProps = {
    name: string;
    gridSize: number;
};

const MobileTableCellAlignmentTool = ({ name, gridSize }: MobileTableCellAlignmentToolProps): ReactElement => {
    const sheetProps = useSheet(SheetId.TableCellAlignmentTool);
    const { isOpen, openSheet } = sheetProps;
    const { commonTextAlignment, commonVerticalAlignment, isDisabled } = useTableCellAlignmentToolState();

    return (
        <>
            <ToolbarTool name={name} isOpen={isOpen} onClick={() => openSheet()} disabled={isDisabled}>
                <Icon
                    gridSize={gridSize}
                    name={`toolbar-align-${commonTextAlignment?.toLowerCase() || 'justified'}`}
                />
            </ToolbarTool>
            <MobileTableCellAlignmentSheet
                sheetProps={sheetProps}
                commonTextAlignment={commonTextAlignment}
                commonVerticalAlignment={commonVerticalAlignment}
            />
        </>
    );
};

export default MobileTableCellAlignmentTool;
